import React from "react";
import { Outlet } from "react-router-dom";
import { SiteHeader } from "./SiteHeader";
import { SiteFooter } from "./SiteFooter";
import { TrialBanner } from "../TrialBanner";

export function Layout() {
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <SiteHeader />
      <TrialBanner />
      <main className="flex-1">
        <Outlet />
      </main>
      <SiteFooter />
    </div>
  );
}
